<template>
  <div>
    <Hero />
    <div id="content">
      <Features />
    </div>
  </div>
</template>

<script>

import Hero from '@/components/learning/Hero.vue'
import Features from '@/components/learning/Features.vue'

export default {
  components: {
    Hero,
    Features
  },
  head({ $seo }) {
    return $seo({
      title: 'Improve Your Photography Skills',
      description:
        'Learning and coaching services for photographers. Professional critique. Mentoring. Community reviews. All levels.'
    })
  }
}
</script>
